import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  // withState,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { Modal, TableBody, TextField } from '@material-ui/core';
import moment from 'moment';
import { sendLogin } from '../../auth/Auth';
import ValidationText from '../../components/atoms/ValidationText';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import UnusedGochiKidConfirmModal from './UnusedGochiKidConfirmModal';
import { unusedGochiKid, UNUSED_GOCHI_KID_SUCCESS } from '../../actions/Gochis';
import AnyButton from '../../components/atoms/AnyButton';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'auto',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  pageTextNote: {
    color: 'red',
    fontSize: 14,
    fontWeight: 700,
    paddingLeft: 30,
    paddingTop: 5,
    paddingBottom: 5,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          unusedGochiKid
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('canUseDate', 'setCanUseDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('preUseDate', 'setPreUseDate', null),
  withState('preUseAmount', 'setPreUseAmount', 0),
  withState('preUseCount', 'setPreUseCount', 0),
  withState('debtAmount', 'setDebtAmount', 0),
  withState('canUseDateError', 'setCanUseDateError', ''),
  withState('preUseAmountError', 'setPreUseAmountError', ''),
  withState('preUseCountError', 'setPreUseCountError', ''),
  withState('debtAmountError', 'setDebtAmountError', ''),
  withState('openConfirm', 'updateOpenConfirm', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({})
);

const Main = enhance(
  ({
    classes,
    targetRowId,
    checkSession,
    actions,
    progress,
    updateOpenUnusedModal,
    openConfirm,
    updateOpenConfirm,
    canUseDate,
    setCanUseDate,
    preUseDate,
    setPreUseDate,
    preUseAmount,
    setPreUseAmount,
    preUseCount,
    setPreUseCount,
    debtAmount,
    setDebtAmount,
    canUseDateError,
    setCanUseDateError,
    preUseAmountError,
    setPreUseAmountError,
    preUseCountError,
    setPreUseCountError,
    debtAmountError,
    setDebtAmountError
  }) => {
    const errors = {
      canUseDateError,
      preUseAmountError,
      preUseCountError,
      debtAmountError
    };

    const params = {
      gochiKidUseId: targetRowId,
      canUseDate,
      preUseDate,
      preUseAmount,
      preUseCount,
      debtAmount
    };

    const handleChangeCanUseDate = value => {
      if (value) {
        const newVal = moment(value);
        const res = canUseDate ? moment(canUseDate) : moment();
        res.set({
          year: newVal.get('year'),
          date: newVal.get('date'),
          month: newVal.get('month')
        });
        setCanUseDate(res.format('YYYY-MM-DD'));
      } else {
        setCanUseDate(null);
      }
    };

    const handleChangePreUseDate = value => {
      if (value) {
        const newVal = moment(value);
        const res = preUseDate ? moment(preUseDate) : moment();
        res.set({
          year: newVal.get('year'),
          date: newVal.get('date'),
          month: newVal.get('month')
        });
        setPreUseDate(res.format('YYYY-MM-DD'));
      } else {
        setPreUseDate(null);
      }
    };

    const validCanUseDate = () => {
      const value = canUseDate;
      if (value === null) {
        setCanUseDateError('必須項目です。');
        return 1;
      }

      setCanUseDateError('');
      setCanUseDate(value);
      return 0;
    };

    const validPreUseAmount = () => {
      const value = preUseAmount;

      if (value === '') {
        setPreUseAmountError('必須項目です。');
        return 1;
      }

      if (!/^\d+$/.test(value)) {
        setPreUseAmountError('半角数字のみ入力してください。');
        return 1;
      }

      setPreUseAmountError('');
      setPreUseAmount(value);
      return 0;
    };

    const validPreUseCount = () => {
      const value = preUseCount;

      if (value === '') {
        setPreUseCountError('必須項目です。');
        return 1;
      }

      if (!/^\d+$/.test(value)) {
        setPreUseCountError('半角数字のみ入力してください。');
        return 1;
      }

      setPreUseCountError('');
      setPreUseCount(value);
      return 0;
    };

    const validDebtAmount = () => {
      const value = debtAmount;

      if (value === '') {
        setDebtAmountError('必須項目です。');
        return 1;
      }

      if (!/^\d+$/.test(value)) {
        setDebtAmountError('半角数字のみ入力してください。');
        return 1;
      }

      setDebtAmountError('');
      setDebtAmount(value);
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      errorCount =
        validCanUseDate() +
        validPreUseAmount() +
        validPreUseCount() +
        validDebtAmount();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenConfirm(true);
      }
    };

    const backAction = () => {
      updateOpenConfirm(false);
    };

    const unusedAction = async () => {
      progress.updateOpenProgress(true);
      progress.updateLoading(true);
      const response = await actions
        .unusedGochiKid(params)
        .then(data => checkSession(data));

      if (response.type === UNUSED_GOCHI_KID_SUCCESS) {
        updateOpenConfirm(false);
        updateOpenUnusedModal(false);
        progress.updateLoading(false);
        progress.setResultMessage('設定更新を完了しました。');
        progress.setIsReCallSearch(true);
      } else {
        progress.updateLoading(false);
        progress.setResultMessage('エラーが発生しました！');
      }
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">こどもごちめし未使用</Typography>
        </div>
        <div className={classes.pageTextNote}>
          こどもごちめしの利用履歴を削除（未使用扱いに）する機能は、弊社（Gigi株式会社）が「こどもごちめし」の利用テストを行うために設けたものです。
          <br />
          そのため、弊社が管理するテスト用アカウントでのみご利用ください。
          <br />
          ※なお、検証環境においてはこの限りではありません。
          <br />
          <br />
          レシート登録が必要な場合は、「レシート再登録（1回限り）」を利用した後に利用履歴を未使用に変更しても、レシート再登録の権利は復活しません。
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="次回利用可能日"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={canUseDate}
                    onChange={e => {
                      handleChangeCanUseDate(e.target.value);
                    }}
                    onBlur={validCanUseDate}
                  />
                  <ValidationText message={errors.canUseDateError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="事前利用額"
                    className={classes.textField}
                    margin="normal"
                    value={preUseAmount}
                    onChange={e => {
                      setPreUseAmount(e.target.value.trim());
                    }}
                    onBlur={validPreUseAmount}
                  />
                  <ValidationText message={errors.preUseAmountError} />
                  これは、今回の利用周期内に使った金額を指しています。
                  <br />
                  資金グループごとに設定されている利用額制限を超えると、その周期内では利用できません。
                  <br />
                  ※ただし、一般世帯についてはこの制限は適用されません。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="事前利用回数"
                    className={classes.textField}
                    margin="normal"
                    value={preUseCount}
                    onChange={e => {
                      setPreUseCount(e.target.value.trim());
                    }}
                    onBlur={validPreUseCount}
                  />
                  <ValidationText message={errors.preUseCountError} />
                  これは、今回の利用周期内に利用された回数を指します。
                  <br />
                  資金グループごとに設定されている利用回数制限を超えると、その周期内では利用できません。
                  <br />
                  ※ただし、要支援世帯についてはこの制限は適用されません。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="充当額"
                    className={classes.textField}
                    margin="normal"
                    value={debtAmount}
                    onChange={e => {
                      setDebtAmount(e.target.value.trim());
                    }}
                    onBlur={validDebtAmount}
                  />
                  <ValidationText message={errors.debtAmountError} />
                  こどもごちめしレシート利用機能において発生する金額です。
                  <br />
                  前回のご利用周期に利用すべきではない利用分があった場合、今回の利用周期のご利用可能残高の一部が前回分として充当されました。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="事前利用日"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={preUseDate}
                    onChange={e => {
                      handleChangePreUseDate(e.target.value);
                    }}
                  />
                  <div>
                    今後の運用のためにAI＆Tが追加する項目です。一旦無視してください。
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div>
          <CancelButton
            color="primary"
            onClickAction={() => updateOpenUnusedModal(false)}
          />
          <ConfirmButton onClickAction={() => confirmAction()} />
        </div>

        <Modal className={classes.modal} open={openConfirm}>
          <UnusedGochiKidConfirmModal
            params={params}
            backAction={backAction}
            unusedAction={unusedAction}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
